import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/auth/:type`;

export const authManagementRoutesObj = {
  auth: baseRoute,
} as const;

export type IAuthManagementRouteParams = IExtractRouteParamMap<
  typeof authManagementRoutesObj
>;

export const authManagementPath = createPaths<
  typeof authManagementRoutesObj,
  IAuthManagementRouteParams
>(authManagementRoutesObj);
